import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { map } from "lodash";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function useCountries(refresh) {
  const authContext = useContext(AuthContext);

  const [countries, setCountries] = useState([]);

  const getCountries = async () => {
    const response = await fetchWithInterceptor(
      `/api/integrations/liquor-connect/countries`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": authContext.getToken(),
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      setCountries(map(data, (country) => ({ label: country.name, value: country.name })));
    }
  };

  useEffect(() => {
    getCountries();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh])

  return countries;
}